<template>
  <footer class="footer w-100 align-self-end">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <!-- <router-link :to="{path:'/dashboard'}">Dashboard</router-link> -->
          </li>
        </ul>
      </nav>
      <!-- <div class="copyright">
        &copy; {{year}}, Developed by
        <a href="https://monomark.io/">Monomark</a>.
      </div> -->
      <div class="copyright">
        <span>{{$version? `${$version} |`:'' }}</span> rights reserved eventscoded.com | Questions/Support: <a href="mailto:info@eventscoded.com">info@eventscoded.com</a>
      </div>
    </div>
  </footer>
</template>
<script>

export default {
    data() {
      return {
        year: new Date().getFullYear(),
      }
    },
}

</script>
<style>

</style>
